// src/data/projectsData.js
import appimg1 from "../assets/11.jpg";
import appimg2 from "../assets/12.jpg";
import appimg3 from "../assets/13.jpg";
import appimg4 from "../assets/14.jpg";
import appimg5 from "../assets/15.jpg";
import edul from "../assets/edul.png";
import edul1 from "../assets/edul1.png";
import linka1 from "../assets/linka1.png";
import linka2 from "../assets/linka2.png";
import linka3 from "../assets/linka3.png";
import triplink1 from "../assets/triplink1.png";
import triplink2 from "../assets/triplink2.png";
import triplink3 from "../assets/triplink3.png";
import nova1 from "../assets/nova1.png";
import nova2 from "../assets/nova2.png";
import nova3 from "../assets/nova3.png";
import optimaflow1 from "../assets/optimaflow1.png";
import optimaflow2 from "../assets/optimaflow2.png";
import datapulse1 from "../assets/datapulse1.png";
import datapulse2 from "../assets/datapulse2.png";
import voyagix1 from "../assets/voyagix1.png";
import voyagix2 from "../assets/voyagix2.png";
import taskwave1 from "../assets/taskwave1.png";
import taskwave2 from "../assets/taskwave2.png";
import clienteasy1 from "../assets/clienteasy1.png";
import clienteasy2 from "../assets/clienteasy2.png";
import clienteasy3 from "../assets/clienteasy3.png";
import tontilink1 from "../assets/tontilink1.png";
import tontilink2 from "../assets/tontilink2.png";
import speui1 from "../assets/speui1.png";
import speui2 from "../assets/speui2.png";
import speui3 from "../assets/speui3.png";
import resaflow1 from "../assets/resaflow1.png";
import resaflow2 from "../assets/resaflow2.png";
import camcan1 from "../assets/camcan1.png";
import camcan2 from "../assets/camcan2.png";
import autobackup from "../assets/autobackup.png";
import reactship1 from "../assets/reactship1.png";
import reactship2 from "../assets/reactship2.png";
import cubenova from "../assets/cubenova.png";
import securegate1 from "../assets/securegate1.png";
import securegate2 from "../assets/securegate2.png";
import vulnascan1 from "../assets/vulnascan1.png";
import vulnascan2 from "../assets/vulnascan2.png";
import docuscan1 from "../assets/docuscan1.png";
import docuscan2 from "../assets/docuscan2.png";
import databoot from "../assets/databoot.png";
import asklit from "../assets/asklit.png";
import twitsense1 from "../assets/twitsense1.png";
import twitsense2 from "../assets/twitsense2.png";
import homelink1 from "../assets/homelink1.png";
import homelink2 from "../assets/homelink2.png";
import meteolink1 from "../assets/meteolink1.png";
import meteolink2 from "../assets/meteolink2.png";
import edutrack1 from "../assets/edutrack1.png";
import edutrack2 from "../assets/edutrack2.png";
import devops from "../assets/devops.png";
import restaurant1 from "../assets/restaurant1.jpg";
import restaurant2 from "../assets/restaurant2.jpg";
import restaurant3 from "../assets/restaurant3.jpg";
import restaurant4 from "../assets/restaurant4.jpg";
import restaurant5 from "../assets/restaurant5.jpg";

export const projects = [
  {
    id: "A",
    slug: "spe-store-app-mobile",
    title: "Spe.Store – Application mobile iOS & Android",
    description:
      "Une application mobile complète pour acheter et vendre vos produits facilement. Notifications, paiement en ligne et suivi des commandes inclus.",
    images: [appimg5, appimg1, appimg2, appimg3, appimg4],
  },
  {
    id: "B",
    slug: "spe-store-ecommerce-web",
    title: "Spe.Store – Site web e-commerce",
    description:
      "Une plateforme web moderne et responsive pour gérer votre boutique en ligne. Accédez au site ici : https://site.spe-store-sarl.com/",
    images: [
      "/images/siteimg1.jpg",
      "/images/siteimg2.jpg",
      "/images/siteimg3.jpg",
      "/images/siteimg4.jpg",
      "/images/siteimg5.jpg",
    ],
  },
  {
    id: "C",
    slug: "logiciel-interne-gestion-processus",
    title: "Logiciel interne de gestion",
    description:
      "Outil B2B pour optimiser les processus internes et la gestion des équipes dans les entreprises.",
    images: [optimaflow1, optimaflow2],
  },
  {
    id: "D",
    slug: "api-analytics-temps-reel",
    title: "API Analytics",
    description:
      "API en temps réel pour l’analyse des données et la génération de rapports automatisés.",
    images: [datapulse1, datapulse2],
  },
  {
    id: "E",
    slug: "gestion-agences-voyages-interurbaines",
    title: "Plateforme Web de Gestion d’Agences de Voyages Interurbaines",
    description:
      "Gestion avancée des clients, billets (eKYC), prix et escales.",
    images: [voyagix1, voyagix2],
  },
  {
    id: "F",
    slug: "gestion-tontines-en-ligne",
    title: "Application Web de Gestion de Tontines",
    description:
      "Gestion des épargnes, crédits, dettes, remboursements et dépenses.",
    images: [tontilink1, tontilink2],
  },
  {
    id: "G",
    slug: "reservation-tickets-voyage",
    title: "Application Mobile de Réservation de Tickets de Voyage",
    description:
      "Réservation de billets auprès d’agences proches avec validation automatique.",
    images: [triplink1, triplink2, triplink3],
  },
  {
    id: "H",
    slug: "api-ocr-documents",
    title: "API OCR de Documents",
    description:
      "Extraction rapide et précise de texte à partir d’images (OCR).",
    images: [docuscan1, docuscan2],
  },
  {
    id: "I",
    slug: "chatbot-rag-donnees-metier",
    title: "Chatbot Basé sur les Données d’une Application Web",
    description:
      "Chatbot RAG connecté aux données et documents de l’application.",
    images: [databoot],
  },

  // 1. Sites web & Applications mobiles
  {
    id: "J",
    slug: "plateforme-elearning-responsive",
    title: "Plateforme e-learning responsive",
    description:
      "Site + app (React / React Native) où les étudiants suivent des cours, progressent et passent des quiz.",
    images: [edul, edul1],
  },
  {
    id: "K",
    slug: "mini-reseau-social-temps-reel",
    title: "Mini-réseau social",
    description:
      "Mur de posts, likes, commentaires, messagerie temps réel (Firebase/Socket.io).",
    images: [linka1, linka2, linka3],
  },

  // 2. Logiciels métier & API
  {
    id: "L",
    slug: "crm-leger-pme",
    title: "CRM léger pour PME",
    description:
      "Gestion clients, suivi des ventes, facturation basique, export PDF.",
    images: [clienteasy1, clienteasy2, clienteasy3],
  },
  {
    id: "M",
    slug: "api-rest-todo-analytics",
    title: "API REST “ToDo+Analytics”",
    description:
      "Gestion des tâches + statistiques (répartition, productivité).",
    images: [taskwave1, taskwave2],
  },

  // 3. UI/UX & Design système
  {
    id: "N",
    slug: "design-system-spe-ui",
    title: "Design System “Spe.UI”",
    description:
      "Librairie de composants réutilisables (boutons, cartes, modales, formulaires) en React/Tailwind.",
    images: [speui1, speui2, speui3],
  },
  {
    id: "O",
    slug: "refonte-ux-reservation",
    title: "Refonte UX d’une app existante",
    description:
      "Refaire l’UX d’une app de réservation pour la rendre plus intuitive (wireframes + maquette Figma).",
    images: [resaflow1, resaflow2],
  },

  // 4. Maintenance & Support (TMA)
  {
    id: "P",
    slug: "dashboard-monitoring-temps-reel",
    title: "Dashboard de monitoring",
    description:
      "Suivi de l’état des serveurs/apps (uptime, erreurs, logs, alertes temps réel).",
    images: [camcan1, camcan2],
  },
  {
    id: "Q",
    slug: "script-automatisation-backup",
    title: "Script d’automatisation",
    description:
      "Backups quotidiens d’une base de données avec alertes email.",
    images: [autobackup],
  },

  // 5. Cloud & DevOps
  {
    id: "R",
    slug: "pipeline-deploiement-react-ci-cd",
    title: "Déploiement continu d’un site React",
    description:
      "Pipeline CI/CD (GitHub Actions → Docker) + déploiement sur AWS/Vercel.",
    images: [reactship1, reactship2],
  },
  {
    id: "S",
    slug: "cluster-kubernetes-hello-world",
    title: "Cluster Kubernetes “Hello World”",
    description:
      "Déploiement d’un microservice simple (API/app web) avec scalabilité auto.",
    images: [cubenova],
  },

  // 6. Cybersécurité
  {
    id: "T",
    slug: "portail-securise-mfa",
    title: "Portail sécurisé avec MFA",
    description:
      "Authentification par mot de passe + 2FA (SMS/app mobile).",
    images: [securegate2, securegate1],
  },
  {
    id: "U",
    slug: "scanner-vulnerabilites-web",
    title: "Scanner de vulnérabilités",
    description:
      "Scan d’URL et détection de failles basiques (headers, HTTPS, XSS potentiel).",
    images: [vulnascan1, vulnascan2],
  },

  // 7. Intelligence Artificielle & Data
  {
    id: "V",
    slug: "chatbot-faq-intelligent",
    title: "Chatbot FAQ intelligent",
    description:
      "Répond aux questions courantes d’un site (API OpenAI/Rasa).",
    images: [asklit],
  },
  {
    id: "W",
    slug: "analyse-sentiments-twitter",
    title: "Analyse des sentiments Twitter",
    description:
      "Collecte via API, analyse positive/négative, affichage graphique.",
    images: [twitsense1, twitsense2],
  },

  // 8. E-commerce & Solutions transactionnelles
  {
    id: "X",
    slug: "boutique-en-ligne-minimaliste",
    title: "Boutique en ligne minimaliste",
    description:
      "Panier, paiement Stripe/PayPal, suivi des commandes.",
    images: [nova1, nova2, nova3],
  },

  // 9. IoT & Objets connectés
  {
    id: "Z",
    slug: "smart-home-dashboard",
    title: "Smart Home Dashboard",
    description:
      "Contrôle d’ampoules, thermostat, caméra (mockup ou API simulée).",
    images: [homelink1, homelink2],
  },
  {
    id: "AA",
    slug: "capteur-meteo-connecte",
    title: "Capteur météo connecté",
    description:
      "Envoi de température/humidité (Arduino/ESP32) vers un dashboard web.",
    images: [meteolink1, meteolink2],
  },

  // 10. Formation & Conseil
  {
    id: "AB",
    slug: "mini-plateforme-lms",
    title: "Mini-plateforme LMS",
    description:
      "Les formateurs publient des cours, les étudiants s’inscrivent et suivent leur progression.",
    images: [edutrack1, edutrack2],
  },
  {
    id: "AC",
    slug: "kit-demarrage-devops",
    title: "Kit de démarrage DevOps",
    description:
      "Repo ‘starter kit’ avec CI/CD + Docker prêt à l’emploi pour initier les entreprises.",
    images: [devops],
  },

  // Site web restaurant à vendre
  {
    id: "AD",
    slug: "site-restaurant-a-vendre",
    title: "Site Web de Restaurant – À Vendre",
    description:
      "Site web complet pour un restaurant : menu en ligne, galerie photos, système de réservation, gestion des commandes en ligne et blog intégré. Inclut une application d'administration dédiée pour gérer l'ensemble du contenu. Projet clé en main disponible à la vente.",
    images: [restaurant1, restaurant2, restaurant3, restaurant4, restaurant5],
  },
];

